module.exports = __webpack_public_path__ + "img/lg_ring_r_s_1_1@3x.51a4c5d5.png";